/**
 * Short intro texts for each method, displayed on the landing page
 * when a method bubble is focused in the orbit center.
 * Keep these concise — 2-3 sentences max.
 */
const LANDING_INTROS = {
  gauss:
    'Gaussian Elimination systematically transforms a linear system into upper triangular form using row operations, then solves by back substitution. It is the go-to direct method for solving systems of linear equations.',

  newton:
    "Newton's Method finds roots of nonlinear equations by repeatedly linearising the function and solving the resulting tangent-line equation. With a good starting guess it converges extremely fast — quadratically.",

  interpolation:
    'Interpolation constructs a smooth curve that passes exactly through a given set of data points. Choose from polynomial, Lagrange, or spline approaches depending on your accuracy and smoothness needs.',

  linearfit:
    'Polynomial Least Squares finds the polynomial of a chosen degree that best fits a set of data points in the least-squares sense. It is a fundamental tool in regression analysis and curve fitting.',

  decomposition:
    'Matrix Decompositions factor a matrix into structured components — LU, QR, Cholesky or SVD — making it easier to solve systems, compute determinants, and analyse stability.',

  iterlinsolve:
    'Iterative solvers like Jacobi, Gauss-Seidel, and Conjugate Gradient approximate the solution of large linear systems step by step, often much more efficiently than direct methods for sparse matrices.',

  quadrature:
    'Numerical Quadrature approximates definite integrals by evaluating the integrand at selected points and combining the values with appropriate weights. Methods range from simple trapezoidal rules to high-order Gauss formulas.',

  simplex:
    'The Simplex Algorithm solves linear programming problems by walking along the edges of the feasible polytope, moving to neighbouring vertices with better objective values until the optimum is reached.',
};

export default LANDING_INTROS;
